import React
// { useState } 
from 'react';
// import { useForm } from 'react-hook-form';
// import { Link } from 'react-router-dom';
// import Logo from '../../images/logo2.png';
import './StyleUser.css';
// import { useAuth } from './useAuth';
// import { useAuth } from "../SignUp/useAuth";
// import userPhoto from '../../images/ICON/Group 2.png';
// import { Link } from 'react-router-dom';

const User = () => {
    
    // const auth = useAuth();

    return (
        <div className="shipment container my-5">
            <div className="restaurant-info mb-3">
                <h1>This page is under construction, Thanks.</h1>
                 {/* {
                            auth.user ?
                                <Link to='' className='nav-link'>
                                    {auth.user.displayName}
                                    <img className='ml-3' src={auth.user.photoURL ? auth.user.photoURL : userPhoto} width="100px" alt=""  style={{ borderRadius: '50%' }}/>
                                </Link>
                                :
                                <Link to='' className='nav-link'>Login</Link>
                        } */}
            </div>
        </div>
    
    
    



    );
};

export default User;